// extracted by mini-css-extract-plugin
export default {"previewContainer":"styles_previewContainer__EcpsJ","preview":"styles_preview__oK59A","completed":"styles_completed__h1HRc","startButton":"styles_startButton__yjkrY"};